import React from "react";
import { Box, Card, Grid, Typography } from "@mui/material";

import {
  PlaylistCreationEnum,
  PlaylistCreationType,
} from "../../../@types/playlist.types";
import PlaylistDataTable from "../../../components/Modals/PlaylistGenerateModal/components/PlaylistDataTable";
import CustomPlaylistList from "../../../components/Modals/PlaylistGenerateModal/components/CustomPlaylistList";
import EmptyPlaylistState from "../../../components/PlaylistsTable/EmptyPlaylistState";
import { Video } from "../../../api/types";
import { sortByDate } from "../../../utils/sortingUtils";

const SinglePlaylistMediaList = ({
  mediaList,
  creationType,
  sortType,
  onRemoveVideo,
  onReorderVideos,
}: {
  mediaList: Video[];
  creationType: PlaylistCreationType;
  sortType: string;
  onRemoveVideo: (mediaToken: string) => void;
  onReorderVideos: (oldIndex: number, newIndex: number) => void;
}) => {
  const isCustomPlaylist = creationType === PlaylistCreationEnum.CUSTOM;
  const isManualSort = isCustomPlaylist && sortType === "manual";

  const sortedMediaList = React.useMemo(() => {
    if (sortType !== "manual") {
      return sortByDate(mediaList, sortType);
    }
    return mediaList;
  }, [mediaList, sortType]);

  return (
    <Box>
      <Card sx={{ borderColor: "#000" }}>
        {/* eslint-disable-next-line no-nested-ternary */}
        {isCustomPlaylist && mediaList.length === 0 ? (
          <EmptyPlaylistState description="Click 'ADD VIDEOS' to select and add videos to your playlist." />
        ) : isManualSort ? (
          <CustomPlaylistList
            videos={sortedMediaList}
            onReorder={onReorderVideos}
            onRemove={onRemoveVideo}
            showRemoveButton={isCustomPlaylist}
            style={{ maxHeight: "600px" }}
          />
        ) : (
          <PlaylistDataTable
            videos={sortedMediaList}
            onRemove={onRemoveVideo}
            rowSize={10}
            showRemoveButton={isCustomPlaylist}
          />
        )}
      </Card>

      {/* Sort Type Notes - only show when there are videos */}
      {mediaList.length > 0 && (sortType === "shuffle" || isManualSort) && (
        <Grid container spacing={2} sx={{ marginTop: "1px" }}>
          <Grid item xs={12} md={12} xl={12}>
            <Typography sx={{ fontSize: "11px" }}>
              {sortType === "shuffle"
                ? "Note: Shuffle is enabled, and the video order will be randomized."
                : "Note: Manual sort is enabled. You can drag and drop videos to reorder them."}
            </Typography>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default SinglePlaylistMediaList;
